// src/lib/businessId.ts
import { supabase } from './supabase';

/** קובע את businessId “היעיל” למשתמש:
 *  1) users.business_id אם קיים
 *  2) המנוי האחרון של המשתמש (subscriptions.business_id)
 *  3) העסק האחרון בבעלות/שיוך (businesses.owner_user_id/user_id)
 */
export async function getEffectiveBusinessId(userId: string): Promise<string | null> {
  try {
    // 1) users.business_id
    const { data: u } = await supabase
      .from('users')
      .select('business_id')
      .eq('id', userId)
      .maybeSingle();
    if (u?.business_id) return u.business_id as string;

    // 2) subscriptions האחרונה
    const { data: s } = await supabase
      .from('subscriptions')
      .select('business_id')
      .eq('user_id', userId)
      .not('business_id', 'is', null)
      .order('created_at', { ascending: false })
      .limit(1)
      .maybeSingle();
    if (s?.business_id) return s.business_id as string;

    // 3) businesses לפי owner_user_id או user_id (האחרון בזמן)
    const { data: b } = await supabase
      .from('businesses')
      .select('id')
      .or(`owner_user_id.eq.${userId},user_id.eq.${userId}`)
      .order('created_at', { ascending: false })
      .limit(1)
      .maybeSingle();
    if (b?.id) return b.id as string;

    return null;
  } catch {
    return null;
  }
}

/** שומר businessId בלוקאל (namespaced + תאימות) ומנסה (Best-Effort) להשלים users.business_id אם חסר */
export async function setBusinessIdForUser(userId: string, businessId: string) {
  try {
    localStorage.setItem(`lf.pinnedBusinessId.${userId}`, businessId);
    localStorage.setItem('businessId', businessId); // תאימות לאחור
  } catch {}

  try {
    await supabase
      .from('users')
      .update({ business_id: businessId })
      .eq('id', userId)
      .is('business_id', null);
  } catch {}
}
